import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import finkraftLogo from '../assets/finkraftlogo.png';
import fk from '../assets/finkraftlogo.png';
import './styles.scss'

const Login = () => {
  const [username, setUsername] = useState('');
  const [otp, setOtp] = useState('');
  const [errors, setErrors] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [modalMessage, setModalMessage] = useState(false); // ✅ state for modal

  // const getEmail = () => `${username.trim()}@kgrp.in`;

  const validateUsername = () => {
    const errs = {};
    if (!username.trim()) errs.username = "Username is required";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

 const handleSendOtp = async () => {
  if (!validateUsername()) return;
  setLoading(true);
  try {
    await axios.post('https://bcd-prospect-admin.finkraftai.com/api/send-otp', {
      email: username.trim(),
    });
    setOtpSent(true);
    setErrors({});
  } catch (e) {
    if (e.response && e.response.status === 400) {
      // Show popup for invalid domain
      setModalMessage("You don't have access to this portal");  // ✅ shows popup with "Invalid email domain"
    } else {
      setErrors({ form: "Error sending OTP. Please try again." });
    }
  } finally {
    setLoading(false);
  }
};



 const handleVerifyOtp = async () => {
  if (!otp.trim()) {
    setErrors({ otp: "Please enter the OTP sent to your email" });
    return;
  }

  setLoading(true);
  try {
    const res = await axios.post('https://bcd-prospect-admin.finkraftai.com/api/verify-otp', {
      email: username.trim(),
      otp: otp.trim(),
    });

    if (res.data.success && res.data.token) {
      // ✅ Save JWT token and email to localStorage
      localStorage.setItem('bcd_token', res.data.token);
      localStorage.setItem('bcd_email', username.trim());

      navigate('/dashboard'); // Redirect only after saving
    } else {
      setErrors({ otp: res.data.message || "Invalid OTP. Please try again." });
    }
  } catch (e) {
    setErrors({ otp: "Invalid OTP or error verifying OTP" });
  } finally {
    setLoading(false);
  }
};


  return (
    <div>
      {/* Logos */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: '10px',
        paddingLeft: '6%', paddingTop: '40px'
      }}>
        <img src={fk} alt="Finkraft Logo" style={{ height: '30px', width: '150px' }} />
        {/* <div style={{ width: '3px', height: '40px', backgroundColor: 'black' }}></div> */}
        {/* <img src={BCDLogo} alt="BCD Logo" style={{ height: '55px', width: '160px', marginBottom: '15px' }} /> */}
      </div>

      <div className="auth-container">
        {modalMessage && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>⚠️ Notice</h3>
            <p>{modalMessage}</p>
            <button onClick={() => setModalMessage('')} className="close-btn">OK</button>
          </div>
        </div>
      )}
        <div className="auth-content">
          <div className="main-text">
            <h1>
              Welcome to the <br /><strong>Finkraft</strong><br />
              Partner Portal
            </h1>
          </div>
          <p className="desc">
            Built to help manage accounts, track lead progress, and drive mutual success.
          </p>
          <p className="footer">Log in to stay informed, aligned, and ahead.</p>
        </div>

        <div className="auth-card">
          <h2>Sign in to your account</h2>
          <p className="subtitle">Enter your email address to receive an OTP.</p>

          {/* Username Field */}
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <input
                type="text"
                id="username"
                placeholder="Enter your mail address"
                value={username}
                onChange={e => setUsername(e.target.value.trim())}
                disabled={otpSent}
              />
              {/* <span style={{ color: '#999', fontSize: '1.5em' }}>@kgrp.in</span> */}
            </div>
            {errors.username && <p className="error">{errors.username}</p>}
          </div>

          {/* Send OTP button (first step) */}
          {!otpSent && (
            <button
              className="submit-btn"
              onClick={handleSendOtp}
              disabled={loading}
              style={{ marginBottom: '1em' }}
            >
              {loading ? 'Sending OTP...' : 'Send OTP'}
            </button>
          )}

          {/* OTP Field (second step) */}
          {otpSent && (
            <>
              <div className="form-group">
                <label htmlFor="otp">Enter OTP</label>
                <input
                  type="text"
                  id="otp"
                  placeholder="Enter OTP sent to your email"
                  value={otp}
                  onChange={e => setOtp(e.target.value)}
                />
                {errors.otp && <p className="error">{errors.otp}</p>}
              </div>
              <button
                className="submit-btn"
                onClick={handleVerifyOtp}
                disabled={loading}
                style={{ marginBottom: '1em' }}
              >
                {loading ? 'Verifying...' : 'Verify OTP'}
              </button>
              <div style={{ fontSize: '0.9em', marginTop: '-0.7em', marginBottom: '1em' }}>
                Didn’t get the OTP?&nbsp;
                <span style={{ color: "#3949ab", cursor: 'pointer' }} onClick={handleSendOtp}>
                  Resend OTP
                </span>
              </div>
            </>
          )}

          {/* Form errors */}
          {errors.form && <p className="error">{errors.form}</p>}
        </div>
      </div>
    </div>
  );
};

export default Login;